module.exports = __webpack_public_path__ + "static/media/heartbox.261d6ea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/heartbox.svg
// module id = 649
// module chunks = 0